export default __webpack_public_path__ + "static/media/feedback.8728aea1.svg";